import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import LandingPage from "@/pages/LandingPage";
import BusinessCard from "@/components/BusinessCard";
import AdvisorCard from "@/components/AdvisorCard";
import BlogHub from "@/pages/BlogHub";
import BlogPost from "@/pages/BlogPost";
import BookOnline from "@/pages/BookOnline";
import BlackMountain from "@/pages/BlackMountain";
import Marion from "@/pages/Marion";

export function AppContent() {
  return (
    <div className="font-body">
      <Toaster
        position="top-right"
        theme="light"
        toastOptions={{
          style: {
            fontFamily: "'Outfit', sans-serif",
            background: '#FFFFFF',
            border: '1px solid #E4DCCF',
            color: '#1A221E',
          },
        }}
      />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/card" element={<BusinessCard />} />
        <Route path="/advisor" element={<AdvisorCard />} />
        <Route path="/blog" element={<BlogHub />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/book-online" element={<BookOnline />} />
        <Route path="/black-mountain" element={<BlackMountain />} />
        <Route path="/marion" element={<Marion />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
